'use strict';

import $ from 'jquery';
import "core-js/stable";
import "regenerator-runtime/runtime";

$(function(){

  //--------------------------------------------------
  // メニュー初期状態を設定
  //--------------------------------------------------
  var menu_statuses = loadSetting();
  var MENU_CURRENT_CLASS = 'is-current';
  var MENU_OPEN_CLASS = 'is-active';
  // 各展開可能アイテムに固有ID値を設定する
  $('#js-drawer-nav .mp-category-header,.mp-category-list a').each(function(){
    var self = $(this);
    // 固有ID値を設定
    self.attr('id', uniqId(self));
  });

  //--------------------------------------------------
  // メニュー開閉状態のリセット判定
  //--------------------------------------------------
  if ( 0 != $('#RESETMENU').length || window.location.search.match('resetmenu') ) {
    console.log('reset menu.');
    saveSetting(null);
    menu_statuses = loadSetting();
    // 全て開いた状態で記憶させる
    $('#js-drawer-nav .mp-category-header').each(function(){
      menu_statuses.active_ids[ $(this).attr('id') ] = true;
    });
    saveSetting(menu_statuses);
  }

  // カレントのメニューを設定
  if ( menu_statuses.current_id ) {
    $('#js-drawer-nav .' + MENU_CURRENT_CLASS).removeClass(MENU_CURRENT_CLASS);
    $('#' + menu_statuses.current_id).addClass(MENU_CURRENT_CLASS);
  }
  // スクロール位置を設定
  if ( 'number' == typeof menu_statuses.scroll ) {
    // 現在のスレッド処理が完了しないとDOM変更とスタイル適用が反映されないので、非同期でスクロール位置を設定する
    setTimeout( function(){
      $("#js-drawer-nav").scrollTop( menu_statuses.scroll );
    }, 1 )
  }

  /*
  // より適切なカレントのメニューが存在する？
  var mached_roots = [];
  var is_match_current = false;
  var current_link = $('#js-drawer-nav a[href^="' + relationalUrl() + '"]');
  current_link.each(function(){
    var root = rootMenu($(this));
    if ( root.hasClass(MENU_CURRENT_CLASS) ) {
      is_match_current = true;
    }
    else {
      mached_roots.push(root);
    }
  });
  // 現在のカレント設定されているメニュー以外のメニューに、現在のページのURLがマッチしている時
  if ( !is_match_current && 0 < mached_roots.length ) {
    // 既存のカレントを外す
    $('#js-drawer-nav .' + MENU_CURRENT_CLASS).removeClass(MENU_CURRENT_CLASS);
    // カレントを強制移動する
    mached_roots[0].addClass(MENU_CURRENT_CLASS);
    // カレントの記録
    menu_statuses.current_id = mached_roots[0].attr('id');
    saveSetting(menu_statuses);
  }
  */

  // オープン状態のメニューを設定
  initialMenuOpenStatus();

  //--------------------------------------------------
  // 開閉メニューのクリック
  //--------------------------------------------------
  $('#js-drawer-nav').on('click', '.mp-category-header', function(){
    console.log("click!");
    var self = $(this);
    // 開閉するものに MENU_OPEN_CLASS のクラス属性名を付け（外し）て、アコーディオンで開閉
    self.toggleClass(MENU_OPEN_CLASS);
    self.next('.mp-category-list,.mp-category-inner').slideToggle('fast').toggleClass('is-show');
    // 開閉状態の記録
    if ( self.hasClass(MENU_OPEN_CLASS) ) {
      menu_statuses.active_ids[ self.attr('id') ] = true;
    }
    else {
      delete menu_statuses.active_ids[ self.attr('id') ];
    }
    saveSetting(menu_statuses);
  });

  //--------------------------------------------------
  // リンクメニューのクリック
  //--------------------------------------------------
  $('#js-drawer-nav').on('click', 'a[href]', function(){
    // 既存のカレントを外す
    $('#js-drawer-nav .' + MENU_CURRENT_CLASS).removeClass(MENU_CURRENT_CLASS);
    // 新規にクリックしたリンクのルートメニューをカレントにする
    var current = $(this);
    current.addClass(MENU_CURRENT_CLASS);
    // カレントの記録
    menu_statuses.current_id = current.attr('id');
    // スクロール位置の記録
    menu_statuses.scroll = $("#js-drawer-nav").scrollTop();
    saveSetting(menu_statuses);
  });

  // 設定値の保存
  function saveSetting( data ){
    if ( data ) {
      localStorage.setItem( 'npb-sidemenu', JSON.stringify( data ) );
    }
    else {
      localStorage.removeItem( 'npb-sidemenu' )
    }
  }

  // 設定値のロード
  function loadSetting(){
    return JSON.parse( localStorage.getItem( 'npb-sidemenu' ) || JSON.stringify( { current_id: null, active_ids: {}, scroll: 0 } ) );
  }

  // ルートメニューの取得
  /*
  function rootMenu(element){
    while( null != element && 0 != element.length ){
      var parent = element.closest('.mp-category-list,.mp-category-inner').prev('.mp-category-header');
      if ( 0 < parent.length ) {
        element = parent;
      }
      else {
        break;
      }
    }
    return element;
  }
  */

  // 親メニューを取得
  function parentMenu(element){
    element = element.closest('.mp-category-list,.mp-category-inner');
    if ( element.hasClass('mp-category-item') ) {
      return parentMenu(element.parent());
    }
    else {
      return element.prev('.mp-category-header')
    }
  }

  // メニューアイテムの固有ID値の生成
  function uniqId(element){
    var id = '';
    while( null != element && 0 != element.length ){
      let element_text = element.text();
      if ( 'A' == element.prop('tagName') ) element_text = 'A_' + element_text;
      id += utf8BtoA(element_text);
      element = parentMenu( element );
    }
    return id;
  }

  // UTF8のBASE64エンコード
  function utf8BtoA(text){
    var utf8str = String.fromCharCode.apply(null, textEncode(text));
    // base64で変換される'+'と'/'と'='はID値には使用できないので、BASE64で使用せず、ID値に利用可能な'-'と'_'と'--'に変更する
    return btoa(utf8str).replace(/[+]/g, '-').replace(/[/]/g, '_').replace(/[=]/g, '--');
  }

  // IEで
  function textEncode(str) {
    if (window.TextEncoder) {
      return new TextEncoder('utf-8').encode(str);
    }
    var utf8 = unescape(encodeURIComponent(str));
    var result = new Uint8Array(utf8.length);
    for (var i = 0; i < utf8.length; i++) {
      result[i] = utf8.charCodeAt(i);
    }
    return result;
  }

  // 現在の相対URLを取得する
  /*
  function relationalUrl(){
    return location.href.replace(/^https?:\/\/[^/]+/i, '');
  }
  */

  // メニュー開閉の初期状態を反映
  function initialMenuOpenStatus(){
    for ( var id in menu_statuses.active_ids ) {
      // フェイルセーフでID値としてあり得ない値があればスキップ
      if ( ! id.match(/^[0-9a-zA-Z\-_:.]+$/) ) continue;

      var item = $('#'+ id);
      if ( 0 < item.length ) {
        item.addClass(MENU_OPEN_CLASS);
        // jquery#show()を使用していたが、ページロードのタイミングで稀に機能しない不具合が発生し原因が不明なため、
        // cssクラスで表示切替を制御する方式に変更した。
        // （問題発生時は、ページロード直後に動作するはずのCSSで静的に定義されているアニメーションなども発生しないため、ブラウザ不具合が関連している可能性もある）
        item.next('.mp-category-list,.mp-category-inner').slideToggle(0).addClass('is-show');
      }
    }  
  }

});
